import { RefObject } from 'react';
import { useTheme, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  type IPrice,
  type IProduct,
  ProductType,
} from 'services/api/entities/stripe';
import {
  PricingSection,
  FeaturesSection,
  DistributionSection,
  LicenseInfoSection,
} from './components';
import {
  BoxContainer,
  StyledMostPopularLabelContainer,
  StyledMostPopularText,
  StyledStarsIcon,
} from './styled';

type PropsType = {
  product: IProduct;
  distributionRef: RefObject<HTMLDivElement>;
  onClick: (price: IPrice | null) => void;
};

const PricingBox = ({ product, distributionRef, onClick }: PropsType) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { information } = product;
  const { features, productType, licenseInfo } = information;

  const isDesktop = useMediaQuery(theme.breakpoints.up('desktop'));

  return (
    <BoxContainer isHighlighted={productType !== ProductType.Pro}>
      {productType === ProductType.Pro && (
        <StyledMostPopularLabelContainer>
          <StyledStarsIcon />
          <StyledMostPopularText>
            {t('subscription:pricing:mostPopular')}
          </StyledMostPopularText>
        </StyledMostPopularLabelContainer>
      )}
      <PricingSection
        product={product}
        distributionRef={distributionRef}
        onClick={onClick}
      />
      <FeaturesSection
        features={features}
        productType={productType}
        licenseInfo={licenseInfo}
      />
      {isDesktop && (
        <>
          <DistributionSection productType={productType} />
          <LicenseInfoSection
            title={licenseInfo.title}
            description={licenseInfo.description}
          />
        </>
      )}
    </BoxContainer>
  );
};

export default PricingBox;
